module.exports = __webpack_public_path__ + "img/RAquilifer64_ua.a62de89a.webp";